const list = [
    {
        id: 1,
        data: {
            columns: [],
            filters: [],
            label: 'Test 1',
        },
        createdAt: '1906-06-24T00:00:00.000Z',
        entity: 'gps',
    },
    {
        id: 2,
        data: {
            columns: [{
                colId: 'id', hide: true, aggFunc: null, width: 200, pivotIndex: null, pinned: null, rowGroupIndex: null,
            }],
            filters: [],
            label: 'Test 2',
        },
        createdAt: '1906-06-24T00:00:00.000Z',
        entity: 'funds',
    },
]

export default {
    list,
}
